import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_kqast86cfn: FaireBrandEntity = {
  token: "b_kqast86cfn",
  type: "brand",
  name: "Natalia",
  avatarUrl:
    "https://cdn.faire.com/fastly/3c9149662eb3f1bc8f2bc769b5c6dfd91fd758c9fb45243aecdbf07fae5c814b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6698d2ddc452d7894a587e6bd1b8f88907da06b12263fbb63a5c5d0895694f49.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3c9149662eb3f1bc8f2bc769b5c6dfd91fd758c9fb45243aecdbf07fae5c814b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6698d2ddc452d7894a587e6bd1b8f88907da06b12263fbb63a5c5d0895694f49.jpeg",
  location: "Waltham, MA, USA",
  minimumOrderDollars: 89,
  rating: 4.9,
  reviewCount: 101,
  isTopShop: true,
  isInsider: true,
  description:
    "Natalia began its journey by making handmade jewelry in Greece.  We have designed and manufactured jewelry and accessories for Claire's, Justice, The Children's Place, Target, Kohl's, Michaels, and other retailers across North America and Europe. Our brands include Frog Sac, Fun-Weevz, Fablinks, Spikeez, and more.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T02:38:56.357Z",
    importedBy: "entity-db-cli",
  },
};
